import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Events from "@/pages/Events";
import Races from "@/pages/Races";
import Challenges from "@/pages/Challenges";
import ChallengeDetail from "@/pages/ChallengeDetail";
import Activity from "@/pages/Activity";
import Leaderboard from "@/pages/Leaderboard";
import Community from "@/pages/Community";
import Tips from "@/pages/Tips";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import StravaCallback from "@/pages/StravaCallback";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/events" element={<Events />} />
        <Route path="/races" element={<Races />} />
        <Route path="/challenges" element={<Challenges />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/community" element={<Community />} />
        <Route path="/tips" element={<Tips />} />
        <Route path="/profile/:userId" element={<Profile />} />
        <Route path="/strava/callback" element={<StravaCallback />} />
        <Route
          path="/onboarding"
          element={<ProtectedRoute skipOnboardingCheck><Onboarding /></ProtectedRoute>}
        />
        <Route
          path="/dashboard"
          element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
        />
        <Route
          path="/activity"
          element={<ProtectedRoute><Activity /></ProtectedRoute>}
        />
        <Route
          path="/challenges/:id"
          element={<ProtectedRoute><ChallengeDetail /></ProtectedRoute>}
        />
        <Route
          path="/admin"
          element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>}
        />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster theme="dark" position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
